import { toaster } from "kanopi-components/ToastContainer";
import { PaymentGateway } from "kw/api/zeus";
import * as React from "react";
import { CybersourceForm } from "./CybersourceForm";
import { StripeForm } from "./StripeForm";
import { TPaymentFormProps } from "./types";

const paymentFormMap = new Map();
paymentFormMap.set(PaymentGateway.CYBERSOURCE, CybersourceForm);
paymentFormMap.set(PaymentGateway.QBE_CYBERSOURCE, CybersourceForm);
paymentFormMap.set(PaymentGateway.STRIPE, StripeForm);

const PaymentForm: React.FC<TPaymentFormProps> = (props) => {
  const component = paymentFormMap.get(props.paymentGateway);
  if (!component) {
    toaster({
      kind: "ERROR",
      content: "Something went wrong! We've notified the team.",
    });
    return <></>;
  }

  return React.createElement(component, props);
};

export { PaymentForm };
